import { reset2FAOption, sendTwoFA, sendTwoFAPhoneNumber, sendTwoFASms } from "../../services/twofactor.service";
import UserActionTypes from "./user.type";

export const setCurrentUser = (user) => ({
	type: UserActionTypes.SET_CURRENT_USER,
	payload: user,
});

export const setCurrentUserUploadLimits = (companyUploadLimits) => ({
	type: UserActionTypes.SET_COMPANY_UPLOAD_LIMIT,
	payload: companyUploadLimits,
});

export const sms2FAPhoneNumber = (number, navigate) => async (dispatch) => {
	const res = await sendTwoFAPhoneNumber(number);

	if (res.code === 200) {
		navigate("/national-insights");
		dispatch({
			type: UserActionTypes.VERIFY_2FA,
			payload: "2FA Successful",
			verified: true,
		});
	}
};

export const verify2FACode = (twoFaCodeToTest, navigate, type, phoneNumber, rememberTwoFactor) => async (dispatch) => {
	try {
		type = type?.trim() === "sms" ? "sms" : "authenticator";

		let res = null;

		if (type === "sms") {
			res = await sendTwoFASms({
				"2fa_code": [phoneNumber, twoFaCodeToTest],
				remember_two_factor: rememberTwoFactor,
			});
		} else if (type === "authenticator") {
			res = await sendTwoFA({
				"2fa_code": twoFaCodeToTest,
				remember_two_factor: rememberTwoFactor,
			});
		}

		if (res.code === 200) {
			navigate("/national-insights");
			dispatch({
				type: UserActionTypes.VERIFY_2FA,
				payload: "2FA Successful",
				verified: true,
			});
		}
	} catch (error) {
		console.log("error", error);
	}
};

export const resetConfirmed2FA = (navigate) => async (dispatch) => {
	try {
		const res = await reset2FAOption();
		if (res.success) {
			navigate("/national-insights");
			dispatch({
				type: UserActionTypes.RESET_CONFIRMED_2FA,
				payload: "2FA Type Reset",
				verified: true,
			});
		} else {
			throw new Error("Couldn't reset confirmed 2FA setting.");
		}
	} catch (error) {
		console.error("error", error);
	}
};
